import React from 'react'

const WMagazine = props => (
  <svg viewBox="0 0 292 340" {...props}>
    <path d="M217 2v2.4l11 59.2-25.3 182.8-20.9-182.6-7-61.8H133v2.4l10.8 59.2 1.5 13.8-23.2 169-21.5-182.8L102 4.4V2H52v2.4l10.8 59L96.6 338h14.8l35.4-248.4L177.4 338h15l48-336z" />
  </svg>
)

export default WMagazine
